import React from "react";
import classNames from "classnames";
import {StatisticsLabel} from "../components/StatisticsLabel.jsx";
import "./business-data-section.css";
import {QuestionCircleOutlined} from "@ant-design/icons";
import {Divider, Tooltip} from "antd";

export const BusinessDataSection = ({reportData}) => {
    return (
        <div className="business-data-section-container">
            <div className="business-data-section-info-row-title-container">
                <span className="title">{reportData?.name}</span>
                {!!reportData?.tooltip && (
                    <Tooltip title={reportData?.tooltip}>
                        <QuestionCircleOutlined className="form-modal-input-info" />
                    </Tooltip>
                )}
            </div>
            {!!reportData?.value && <StatisticsLabel title={reportData?.value} />}

            {reportData?.children?.length ? (
                <div className="business-data-section-info">
                    {reportData.children.map(({id, name, tooltip, value, color}, index) => {
                        const nameClassName = classNames("business-data-section-text", color);
                        if (name === "divider") {
                            return <Divider key={id || `divider-${index}`} className="business-data-divider" />;
                        }
                        return (
                            <div className="business-data-section-info-row" key={id || index}>
                                <div className="business-data-section-info-row-title-container">
                                    <span className={nameClassName}>{name}</span>
                                    {tooltip ? (
                                        <Tooltip title={tooltip}>
                                            <QuestionCircleOutlined className="form-modal-input-info" />
                                        </Tooltip>
                                    ) : null}
                                </div>
                                <div className="business-data-section-info-row-title-container">
                                    <span>{value}</span>
                                </div>
                            </div>
                        );
                    })}
                </div>
            ) : null}
        </div>
    );
};
